<template>
  <div>
    <div class="container mx-auto flex flex-wrap py-10">
      <router-link tag="div" :to="{name: 'digital'}" class="md:w-1/2 cursor-pointer">
        <div class="md:pr-5 px-4">
          <span class="font-header text-4xl inline-block w-full mb-2 text-center tracking-wide">Peintures numériques</span>
          <img class="w-full h-56 opacity-90 hover:opacity-100 object-cover rounded-lg shadow hover:shadow-xl inline-block mb-4" src="img/dungeon.jpg">
        </div>
      </router-link>
      <router-link tag="div" :to="{name: 'watercolor'}" class="md:w-1/2 cursor-pointer">
        <div class="md:pl-5 px-4">
          <span class="font-header text-4xl inline-block w-full mb-2 text-center tracking-wide">Aquarelles</span>
          <img class="w-full h-56 opacity-90 hover:opacity-100 object-cover rounded-lg shadow hover:shadow-xl inline-block mb-4" src="img/jardin japonais_min.jpg">
        </div>
      </router-link>
      <router-link tag="div" :to="{name: 'cards'}" class="md:w-1/2 cursor-pointer">
        <div class="md:pr-5 px-4">
          <span class="font-header text-4xl inline-block w-full mb-2 text-center tracking-wide">Cartes de voeux</span>
          <img class="w-full h-56 opacity-90 hover:opacity-100 object-cover rounded-lg shadow hover:shadow-xl inline-block mb-4" src="img/perenoel-mini.jpg">
        </div>
      </router-link>
      <router-link tag="div" :to="{name: 'orders'}" class="md:w-1/2 cursor-pointer">
        <div class="md:pl-5 px-4">
          <span class="font-header text-4xl inline-block w-full mb-2 text-center tracking-wide">Commandes</span>
          <img class="w-full h-56 opacity-90 hover:opacity-100 object-cover rounded-lg shadow hover:shadow-xl inline-block mb-4" src="img/NaoetMat-mini.jpg">
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
